import { render } from "./ProductEdit.vue?vue&type=template&id=2a787bcc&scoped=true"
import script from "./ProductEdit.vue?vue&type=script&lang=js"
export * from "./ProductEdit.vue?vue&type=script&lang=js"

import "./ProductEdit.vue?vue&type=style&index=0&id=2a787bcc&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a787bcc"]])

export default __exports__